import '../../App.css';
import './user-control.css';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../app/hooks';

// images
import { LockKeyhole } from 'lucide-react';

// classes
import RoundButton from '../../tools/round-button';

// types
import { NotificationType } from '../../utils/types';

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	H T M L   C U S T O M   C O M P O N E N T S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	C O M P O N E N T   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

//	------------------------------------------------------------
//
//	Displays the login button with a different name depending
//	upon whether we're logged in or not.
//
//	------------------------------------------------------------

export default function UserAccountButton(props: { buttonHandler: any }) {
  //
  //	--------------------------------------------------------------------------
  //
  //	R E D U X   S T A T E   H A N D L I N G
  //
  //	--------------------------------------------------------------------------

  // global state variables.
  const sG_loggedIn: boolean | undefined = useAppSelector(
    (state) => state.global.loggedIn,
  );
  const sG_username: string | undefined = useAppSelector(
    (state) => state.global.username,
  );

  // app state variables.
  const sNotifications: NotificationType[] = useAppSelector(
    (state) => state.app.notifications,
  );

  // local state variables.
  const sInitials: string = useAppSelector((state) => state.userControl.initials);

  //	--------------------------------------------------------------------------
  //
  //	D E C L A R A T I O N S
  //
  //	--------------------------------------------------------------------------

  // translation function
  const { t } = useTranslation();

  //	-------------------------------------------------
  //
  //	count the number of notifications that are
  //	unread.
  //
  //	-------------------------------------------------

  function numUnreadNotifications(args: { notifications: NotificationType[] }) {
    //
    var foundUnread: number = args.notifications.filter(
      (item) => item.readFlag !== true,
    ).length;

    // return something.
    return foundUnread;
    //
  } // numUnreadNotifications

  //	-------------------------------------------------
  //
  //	C O M P O N E N T   C O D E
  //
  //	-------------------------------------------------

  // display 'please wait' if we're logging in.
  if (sG_loggedIn === undefined) {
    return (
      <RoundButton
        name="btnLogin"
        text={t('Please wait') + '...'}
        LucideIcon={LockKeyhole}
      />
    );
  }

  // display the login button if we're not logged in.
  if (sG_loggedIn === false) {
    return (
      <RoundButton
        name="btn-login"
        text={t('Log in')}
        LucideIcon={LockKeyhole}
        onClickHandler={props.buttonHandler}
      />
    );
  }

  // otherwise, display the username.
  return (
    <RoundButton
      name="btn-user-account"
      text={sG_username}
      abbreviatedText={sInitials}
      onClickHandler={props.buttonHandler}
    />
  );
  //
} // UserAccountButton
